import React from "react";
import PropTypes from "prop-types";

const YouTubeEmbed = ({ embedId, landingPage, height, width }) => (
  <div className="video-responsive">
    <iframe
      style={{ borderRadius: landingPage ? "20px" : "10px" }}
      width={width ? width : !landingPage ? "853" : ""}
      height={height ? height : !landingPage ? "480" : ""}
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

YouTubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
};

export default YouTubeEmbed;
